import { countryData } from './countryData';
class CountrySharedUtil {
    getAllCountryData() {
        return countryData;
    }
    getCountryData(code) {
        return countryData[code];
    }
}
export const countrySharedUtil = new CountrySharedUtil();
